export interface ILicenceBilling {
  unitPrice: number;
  subscriptionId: string;
}

export default class LicenceBilling {
  private unitPrice: number;
  private subscriptionId: string;

  constructor(dto: ILicenceBilling) {
    Object.assign(this, dto);
  }

  get getUnitPrice(): number {
    return this.unitPrice;
  }

  set setUnitPrice(unitPrice: number) {
    this.unitPrice = unitPrice;
  }

  get getSubscriptionId(): string {
    return this.subscriptionId;
  }

  set setSubscriptionId(subscriptionId: string) {
    this.subscriptionId = subscriptionId;
  }
}
